export var MemberPaymentCardWalletFormActionType;
(function (MemberPaymentCardWalletFormActionType) {
    MemberPaymentCardWalletFormActionType["OpenModal"] = "OpenModal";
    MemberPaymentCardWalletFormActionType["CloseModal"] = "CloseModal";
    MemberPaymentCardWalletFormActionType["MakePrimaryChosen"] = "MakePrimaryChosen";
    MemberPaymentCardWalletFormActionType["LoadedPaymentCardsClient"] = "LoadedPaymentCardsClient";
    MemberPaymentCardWalletFormActionType["SetError"] = "SetError";
    MemberPaymentCardWalletFormActionType["AddPaymentCardStarted"] = "AddPaymentCardStarted";
    MemberPaymentCardWalletFormActionType["AddPaymentCardButtonStateChanged"] = "AddPaymentCardButtonStateChanged";
    MemberPaymentCardWalletFormActionType["TermsAndConditionsAccepted"] = "TermsAndConditionsAccepted";
    MemberPaymentCardWalletFormActionType["TryAgainButtonClicked"] = "TryAgainButtonClicked";
})(MemberPaymentCardWalletFormActionType || (MemberPaymentCardWalletFormActionType = {}));
